// import React from 'react'
// import { BiMessageSquare, BiTrendingUp } from 'react-icons/bi'
// import { FaUserSecret } from 'react-icons/fa'
// import { FiAlertTriangle } from 'react-icons/fi'

// const WhyAppnext = () => {
//   return (
//     <div >
//            <section className="bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 py-28">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="mb-12">
//           <span className="bg-slate-800 text-white px-6 py-2 rounded-full text-sm font-medium">WHY NETSOL</span>
//         </div>

//         <div className="grid lg:grid-cols-2 gap-16 items-start">
//           {/* Left Content */}
//           <div className="space-y-8">
//             <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
//               Beyond automation, <span className="text-cyan-400">igniting innovation</span> with{" "}
//               <span className="text-slate-900">digital solutions</span>
//             </h2>

//             <div className="space-y-6 text-slate-700 text-lg leading-relaxed">
//               <p>
//                 Businesses are etching change with talent management solutions, exploring exponential growth and
//                 technological revolution. Data and AI are augmenting human expertise and intelligence. NETSOL unlocks a
//                 new dimension of work structure, bridging the gap between human and digital potential.
//               </p>

//               <p>
//                 Being your digital technology partners, we foster innovation and agility, equipping you with
//                 unparalleled talent, unlocking your organization's potential and propelling your projects forward at an
//                 unmatched speed.
//               </p>
//             </div>
//           </div>

//           {/* Right Stats Grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//             <div className="bg-white rounded-2xl p-6 shadow-sm">
//               <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
//                 <FaUserSecret className="w-6 h-6 text-blue-600" />
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-3">Quiet quitting</h3>
//               <p className="text-slate-600 text-sm">
//                 In 2024, "quiet quitting" has become a trend, where over 50% of employees are not ready to put in extra
//                 effort.
//               </p>
//             </div>

//             <div className="bg-white rounded-2xl p-6 shadow-sm">
//               <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
//                 <BiTrendingUp className="w-6 h-6 text-blue-600" />
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-3">Training disparity</h3>
//               <p className="text-slate-600 text-sm">
//                 36% of organizations offer quarterly training to employees, but only 5% provide basic training programs.
//               </p>
//             </div>

//             <div className="bg-white rounded-2xl p-6 shadow-sm">
//               <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
//                 <FiAlertTriangle className="w-6 h-6 text-blue-600" />
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-3">Management failure</h3>
//               <p className="text-slate-600 text-sm">
//                 Poor management leads businesses to lose over $450 billion yearly in productivity.
//               </p>
//             </div>

//             <div className="bg-white rounded-2xl p-6 shadow-sm">
//               <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
//                 <BiMessageSquare className="w-6 h-6 text-blue-600" />
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-3">Interview impact</h3>
//               <p className="text-slate-600 text-sm">
//                 65% of employees lose interest in a job due to a bad interview experience.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//     </div>
//   )
// }

// export default WhyAppnext

import React from 'react';

const WhyAppnext = ({
  whytitle,
  description1,
  description2,
  stats = [],
}) => {
  return (
    <section className="bg-gradient-to-br from-slate-50 via-blue-50 to-slate-50 py-28">
      <div className="max-w-7xl mx-auto px-6">
        {/* Tag Badge */}
        <div className="mb-12">
          <span className="text-white px-6 py-2 rounded-full font-medium bg-blue-700">
            Why AppNexts
          </span>
        </div>

        {/* Left & Right Grid */}
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left Text Content */}
          <div className="space-y-8">
    <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
  {whytitle.split(/(\[\[.*?\]\])/g).map((part, index) => {
    // Check if it's a highlighted part
    if (part.startsWith('[[') && part.endsWith(']]')) {
      const cleanWord = part.replace('[[', '').replace(']]', '');
      return (
        <span key={index} className="text-cyan-400">
          {cleanWord}
        </span>
      );
    }
    return <span key={index}>{part}</span>;
  })}
</h2>



            <div className="space-y-6 text-slate-700 text-lg leading-relaxed">
              <p>{description1}</p>
              <p>{description2}</p>
            </div>
          </div>

          {/* Right Stats Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {stats.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="bg-white rounded-2xl p-6 shadow-sm">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-slate-900 mb-3">{item.title}</h3>
                  <p className="text-slate-600 text-sm">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyAppnext;
